import React from 'react';
import { ReactComponent as FlipSvg } from 'assets/flip-icon.svg';
import './FlipIcon.scss';


type FlipIconProps = {
  onClick?: () => void;
  width?: number;
}

const FlipIcon = (props:FlipIconProps) => {

  const { onClick, width = 32 } = props;
  
  return (
    <div className='flip-icon-container' style={{width}}>
      <FlipSvg className='flip-icon' onClick={onClick}/>
      <span>flip</span>
    </div>
  );
}

export default FlipIcon;
